
export const setBankStatementList = (state, payload) => {
    state.list = payload.response
}    



// WEBPACK FOOTER //
// ./src/store/modules/bankStatement/mutations.js